//
// NOTE:
// Hopefully we can delete this soon once legacy billing pages are updated.
//

import React from "react";
import styled from "styled-components";

import BodyText from "core/BodyText";
import Link from "core/Link";

const Container = styled.div`
    margin-top: 1rem;
    display: flex;
    gap: 0.75rem;

    & > :first-child {
        flex: 0 0 auto;
        font-size: 0.8rem;
        margin-top: 0.125rem;

        // overwrite goofy legacy CSS
        i.ui_important::before {
            margin-right: 0;
        }
    }

    & > :last-child {
        flex: 1 1 auto;
    }
`;

const LegacyPrepaidWarning = () => (
    <Container>
        <div>
            <i className="ui_important" title="Exclamation"></i>
        </div>
        <div>
            <BodyText size="sm">
                We're sorry, but Noun Project can no longer process prepaid
                balance payments. Please{" "}
                <Link
                    href="https://thenounproject.zendesk.com/"
                    target="_blank"
                    size="sm"
                    display="inline"
                >
                    contact customer care
                </Link>{" "}
                for a refund.
            </BodyText>
        </div>
    </Container>
);

export default LegacyPrepaidWarning;
